/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useMigrationSession } from "../../hooks/useMigrationSession";
import { openChat } from "../../utils/providers";

const HubSpotProvider = ({ children }) => {
  const { user } = useAuth();
  const { hash } = useLocation();
  const migration = useMigrationSession();

  useEffect(() => {
    if (user?.conversation_token && user?.email) {
      window.hsConversationsSettings = {
        identificationEmail: user.email,
        identificationToken: user.conversation_token,
      };
    } else {
      window.hsConversationsSettings = undefined;
    }
  }, [user?.conversation_token, user?.email]);

  useEffect(() => {
    let count = 0;
    const interval = setInterval(() => {
      if (typeof HubSpotConversations !== "undefined") {
        HubSpotConversations.resetAndReloadWidget();
        clearInterval(interval);
      } else {
        count++;
        if (count >= 10) {
          clearInterval(interval);
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (hash === "#showchat") {
      openChat();
    }
  }, [hash]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    if (user?.id) {
      window.dataLayer.push({
        event: "UserIdEvent",
        userId: user?.id,
      });
    }

    if (migration?.id) {
      window.dataLayer.push({
        event: "MigrationIdEvent",
        migrationId: migration?.id,
      });
    }
  }, [user?.id, migration?.id]);

  return <>{children}</>;
};

export default HubSpotProvider;
